import axios from '../client/clientAxios';

export default {
    fetchIsLogin() {
        return axios.get(`/member/islogin`)
            .then(res => res.data).catch(e => {throw e})
    },
    login(username, password) {
        return axios.post(`/member/login`,{email: username, pass: password})
            .then(res => res.data).catch(e => {throw e})
    }
}


